import { BomItem } from '../../../resources/designItem/bomItemFrontendTypes';

export function updateDesignItemsQueryKey(bomItem: BomItem) {
    return ['useUpdateDesignItems', bomItem.id.join(',')];
}
